(() => {
  const SECTION_SELECTOR = '[data-reveal-footer]';
  const DESKTOP_MQ = '(min-width: 1100px)';

  const isDesktopReveal = () => window.matchMedia(DESKTOP_MQ).matches;

  const syncAccordions = (footer) => {
    const items = footer.querySelectorAll('[data-footer-accordion]');
    if (!items.length) return;

    const desktop = isDesktopReveal();
    items.forEach((item) => {
      if (desktop) {
        item.open = true;
        item.dataset.desktopForced = 'true';
      } else if (item.dataset.desktopForced === 'true' || !item.dataset.mobileReady) {
        item.open = false;
        item.dataset.desktopForced = 'false';
        item.dataset.mobileReady = 'true';
      }
    });
  };

  const syncRevealFooter = (footer) => {
    if (!footer) return;

    const root = document.documentElement;
    root.classList.add('has-reveal-footer');

    const measure = () => {
      syncAccordions(footer);

      if (!isDesktopReveal()) {
        root.style.removeProperty('--reveal-footer-height');
        footer.classList.add('is-interactive');
        footer.style.height = '';
        return;
      }

      const previousHeight = footer.style.height;
      footer.style.height = 'auto';
      const contentHeight = Math.ceil(footer.scrollHeight);
      footer.style.height = previousHeight;

      const viewportCap = Math.round(window.innerHeight * 0.85);
      const height = Math.max(contentHeight, viewportCap);

      root.style.setProperty('--reveal-footer-height', `${height}px`);
    };

    const onScroll = () => {
      if (!isDesktopReveal()) {
        footer.classList.add('is-interactive');
        footer.classList.add('is-visible');
        return;
      }

      const spacer = footer.closest('.shopify-section')?.querySelector('.footer-reveal-spacer');
      if (!spacer) return;
      const rect = spacer.getBoundingClientRect();
      // Show only once the footer reveal zone reaches the viewport.
      // Instant (no fade) so bottom peeks still feel solid; hidden at page top
      // so overscroll can't reveal the fixed footer behind main content.
      const nearBottom = rect.top < window.innerHeight;
      const awayFromTop = window.scrollY > 8;
      const revealed = nearBottom && awayFromTop;
      footer.classList.toggle('is-interactive', revealed);
      footer.classList.toggle('is-visible', revealed);
    };

    measure();
    onScroll();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      measure();
      onScroll();
    });

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        measure();
        onScroll();
      });
    }

    footer.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', measure, { once: true });
      }
    });

    footer.querySelectorAll('[data-footer-accordion]').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!isDesktopReveal()) measure();
      });
    });
  };

  const init = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach(syncRevealFooter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
